<p-dialog #selectFormDialog
    (onHide)="cancel()"
    [(visible)]="visible"
    appendTo="body"
    styleClass="center-header m-dialog-header-text"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [style]="{ 'max-width': '450px', width: '100%' }"
    header="Select Form" >
    <div class="mt-3">
        <div class="inputs-group" [style.max-width]="'100%'">
            <div class="inputs-group-row">
                <label class="inputs-group-row-name asterisk-mark">Form:</label>
                <div class="inputs-group-row-value">
                    <p-dropdown [options]="definitionDropdownOptions"
                                [showClear]="true"
                                [(ngModel)]="selectedDefinitionId"
                                appendTo="body"
                                placeholder="Select Form">
                    </p-dropdown>
                </div>
            </div>
        </div>

        <form-buttons [disabled]="!selectedDefinitionId" [config]="buttonsConfig"></form-buttons>
    </div>
</p-dialog>